export default __webpack_public_path__ + "static/media/arrowRight.ca32a53c.svg";